import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { InputNumber, Col } from "antd";
var NumberWidget = /*#__PURE__*/function (_PureComponent) {
  function NumberWidget() {
    var _this;
    _classCallCheck(this, NumberWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NumberWidget, [].concat(args));
    _this.handleChange = function (val) {
      if (val === "" || val === null) val = undefined;
      _this.props.setValue(val);
    };
    return _this;
  }
  _inherits(NumberWidget, _PureComponent);
  return _createClass(NumberWidget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        config = _this$props.config,
        placeholder = _this$props.placeholder,
        customProps = _this$props.customProps,
        value = _this$props.value,
        min = _this$props.min,
        max = _this$props.max,
        step = _this$props.step,
        readonly = _this$props.readonly;
      var renderSize = config.settings.renderSize;
      var aValue = value != undefined ? value : undefined;
      return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(InputNumber, _extends({
        disabled: readonly,
        key: "widget-number",
        size: renderSize,
        value: aValue,
        min: min,
        max: max,
        step: step,
        placeholder: placeholder,
        onChange: this.handleChange
      }, customProps)));
    }
  }]);
}(PureComponent);
NumberWidget.propTypes = {
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  config: PropTypes.object.isRequired,
  field: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customProps: PropTypes.object,
  fieldDefinition: PropTypes.object,
  readonly: PropTypes.bool,
  // from fieldSettings:
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number
};
NumberWidget.defaultProps = {
  min: undefined,
  max: undefined,
  step: undefined
};
export { NumberWidget as default };